import thunk from 'redux-thunk';

export default [thunk];
